import { render, staticRenderFns } from "./MarketPlaceWrapper.vue?vue&type=template&id=5f65bf44"
import script from "./MarketPlaceWrapper.vue?vue&type=script&lang=js"
export * from "./MarketPlaceWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports